import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { EditView } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface EditViewAction extends Action {
  view: IContentInfo;
}

export function editView(view: IContentInfo): EditViewAction {
  return {
    type: EditView,
    view
  };
}

export const isEditViewAction = isActionFactory<EditViewAction>(EditView);
